import React from 'react'
import { useParams } from 'react-router'

export const useSurveyForSettingsQueryKey = () => {
  const { surveyId = '' } = useParams<{ surveyId: string | undefined }>()

  return React.useMemo(
    () => ['UseSurveyForSettingsQuery_Main', { surveyId }],
    [surveyId],
  )
}
